import { getPostcodeValidationError } from "../../../../utils";

export const validateAddressSelection = (selectedAddress) => {
  if (!selectedAddress) {
    return " ";
  }
  return "";
};

export const validateManualAddress = (manualAddress) => {
  const errors = {
    addressLine1: "",
    city: "",
    postcode: "",
  };

  if (!manualAddress.addressLine1 || manualAddress.addressLine1.trim() === "") {
    errors.addressLine1 = "Please enter your address";
  }

  if (!manualAddress.city || manualAddress.city.trim() === "") {
    errors.city = "Please enter your city";
  }

  if (!manualAddress.postcode || manualAddress.postcode.trim() === "") {
    errors.postcode = "Please enter your postcode";
  } else {
    const postcodeValidationError = getPostcodeValidationError(
      manualAddress.postcode,
    );
    if (postcodeValidationError) {
      errors.postcode = postcodeValidationError;
    }
  }

  return errors;
};

export const validateMeterType = (meterType) => {
  if (!meterType) {
    return "Please select a meter type";
  }
  return "";
};

export const validateMeterNumber = (meterValidated) => {
  if (!meterValidated) {
    return "Please validate your meter number";
  }
  return "";
};

export const formatAddress = (addressObj) => {
  return (
    addressObj?.meteringPointAddress || addressObj?.MeteringPointAddress || ""
  );
};

export const getSelectPlaceholderText = (
  isLoadingAddresses,
  availableAddresses,
) => {
  if (isLoadingAddresses) {
    return "Loading addresses...";
  }
  if (availableAddresses == null) {
    return "--";
  }
  if (availableAddresses?.length > 0) {
    return "Select your address";
  }
  return "No Adresses found.";
};

export const extractMeterPointDetails = (addressObj) => {
  const profileClassId = addressObj.ProfileClassId || addressObj.profileClassId;
  const meterTimeswitchCode =
    addressObj.MeterTimeswitchCode || addressObj.meterTimeswitchCode;
  const lineLossFactorClassId =
    addressObj.LineLossFactorClassId || addressObj.lineLossFactorClassId;

  return {
    profileClassId,
    meterTimeswitchCode,
    lineLossFactorClassId,
    hasAllDetails: !!(
      profileClassId &&
      meterTimeswitchCode &&
      lineLossFactorClassId
    ),
  };
};
